<template>
    <div>
        <router-link :to="{name: 'editApp', params: {appId: data.appId} }">
            <button
                class="btn btn-primary btn-sm"
                data-toggle="tooltip"
                data-placement="top"
                :title="$t('edit')">
                <i class="glyphicon glyphicon-edit"></i>
            </button>
        </router-link>
        <button
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            :data-target="targetModalId"
            data-placement="top"
            :title="$t('trash')"
            >
            <i class="glyphicon glyphicon-trash"></i>
        </button>

        <div class="modal modal-danger fade" :id="modalId" style="display: none;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span></button>
                        <h4 class="modal-title">Danger</h4>
                    </div>
                    <div class="modal-body">
                        <p>{{$i18n.messages[$i18n.locale].deleteMessage}}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-outline"
                            data-dismiss="modal"
                            @click="$_admin_app_action_remove(data.appId)"
                        >
                            {{$i18n.messages[$i18n.locale].submit}}
                        </button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </div>
</template>
<script>
    import api from '../../api'
    import config from '../../config'
    export default {
        props: {
            data: Object
        },
        data () {
            return {
                modalId: '',
                targetModalId: ''
            }
        },
        mounted () {
            this.modalId = 'modal-danger' + this.data.appId
            this.targetModalId = '#modal-danger' + this.data.appId
        },
        methods: {
            $_admin_app_action_remove (id) {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp
                const headers = {'authorization': this.$store.state.token}
                const params = { ids: id }
                return api.request('delete', path, {}, params, headers)
                    .then(response => {
                        this.$parent.$parent.$children[1].refresh()
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ListAppAction.vue?4a8f5792